<form [formGroup]="userSearchTextForm">
  <div style="display: flex; width: 100%">
    <mc-input-group style="width: 100%" hiddenlegend fit="small">
      <mc-input
        style="width: 100%"
        placeholder="Search for a User Name or Email Address"
        fit="small"
        ngDefaultControl
        formControlName="searchText"
        hiddenlabel
        [clearbutton]="true"
        (clearbuttonclick)="applySearchTextFilters()"
        [attr.invalid]="isControlInErrorState(this.userSearchTextForm.controls.searchText)"
        (keyup.enter)="applySearchTextFilters()">
      </mc-input>
      <mc-button
        variant="filled"
        (keydown.enter)="applySearchTextFilters()"
        (click)="applySearchTextFilters()"
        appearance="secondary"
        label="search"
        fit="small"
        hiddenlabel
        icon="magnifying-glass"></mc-button>
    </mc-input-group>
  </div>
</form>
